import { ChevronUp, ChevronDown } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

export type SortDirection = 'asc' | 'desc' | null

interface SortIndicatorProps {
  direction: SortDirection
  active: boolean
}

export function SortIndicator({ direction, active }: SortIndicatorProps) {
  return (
    <span
      className={cn(
        'ml-1 inline-flex flex-col items-center -space-y-1',
        active ? 'opacity-100' : 'opacity-35'
      )}
    >
      <ChevronUp
        className={cn(
          'h-2.5 w-2.5',
          active && direction === 'asc' ? 'text-[var(--ink)]' : 'text-[var(--ink-3)]',
          active && direction === 'desc' ? 'opacity-30' : 'opacity-100'
        )}
      />
      <ChevronDown
        className={cn(
          'h-2.5 w-2.5',
          active && direction === 'desc' ? 'text-[var(--ink)]' : 'text-[var(--ink-3)]',
          active && direction === 'asc' ? 'opacity-30' : 'opacity-100'
        )}
      />
    </span>
  )
}
